import fs from 'node:fs';
import path from 'node:path';
import { SKILL_DISCOVERY_ROOTS, yieldSkillDiscoveryWork } from './skill-discovery-roots.js';

export type LocalSkillEntry = { skillKey: string; path: string };

function collectSkillFromDir(
  rel: string,
  base: string,
  name: string,
  seenKeys: Set<string>,
  out: LocalSkillEntry[],
): void {
  const dir = path.join(base, name);
  try {
    if (!fs.statSync(dir).isDirectory()) return;
  } catch {
    return;
  }
  const skillMd = path.join(dir, 'SKILL.md');
  if (!fs.existsSync(skillMd)) return;
  const key = `${rel}/${name}`;
  if (seenKeys.has(key)) return;
  seenKeys.add(key);
  out.push({ skillKey: name, path: `${rel}/${name}`.replace(/\\/g, '/') });
}

/**
 * Find skill folders (subdirectory with SKILL.md) under common roots relative to cwd.
 */
export function discoverLocalSkills(cwd: string): LocalSkillEntry[] {
  const out: LocalSkillEntry[] = [];
  const seenKeys = new Set<string>();

  for (const rel of SKILL_DISCOVERY_ROOTS) {
    const base = path.join(cwd, rel);
    if (!fs.existsSync(base) || !fs.statSync(base).isDirectory()) continue;
    let entries: string[] = [];
    try {
      entries = fs.readdirSync(base);
    } catch {
      continue;
    }
    for (const name of entries) {
      collectSkillFromDir(rel, base, name, seenKeys, out);
    }
  }
  return out;
}

/** Like {@link discoverLocalSkills}, yielding so bridge message handling stays responsive. */
export async function discoverLocalSkillsAsync(cwd: string): Promise<LocalSkillEntry[]> {
  const out: LocalSkillEntry[] = [];
  const seenKeys = new Set<string>();
  let work = 0;

  for (const rel of SKILL_DISCOVERY_ROOTS) {
    await yieldSkillDiscoveryWork(++work);
    const base = path.join(cwd, rel);
    if (!fs.existsSync(base) || !fs.statSync(base).isDirectory()) continue;
    let entries: string[] = [];
    try {
      entries = fs.readdirSync(base);
    } catch {
      continue;
    }
    for (let i = 0; i < entries.length; i++) {
      await yieldSkillDiscoveryWork(++work);
      collectSkillFromDir(rel, base, entries[i]!, seenKeys, out);
    }
  }
  return out;
}

/** @deprecated use discoverLocalSkills */
export const discoverLocalAgentSkills = discoverLocalSkills;
